import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@optools/components/ui/table';
import { UserInfo } from '@optools/services/operator-gateway/types/generated/graphql';

export interface UserInfoTableProps {
  userInfo: UserInfo;
}

export function UserInfoTable({ userInfo }: UserInfoTableProps) {
  const { email, firstName, id, lastName } = userInfo;
  return (
    <section>
      <h2 className="mb-2 text-lg font-bold">User Info</h2>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>ID</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>First Name</TableHead>
            <TableHead>Last Name</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            <TableCell>{id}</TableCell>
            <TableCell>{email}</TableCell>
            <TableCell>{firstName}</TableCell>
            <TableCell>{lastName}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </section>
  );
}
